<div style="width:100%">
  <button (click)="toggleEdit()" [hidden]="!editmode || id == 0" class="float-right" style="margin-right:10px;margin-left:10px"><i class="fa fa-times"></i> Cancel</button>
  <button (click)="savePatient()" [hidden]="!editmode" class="float-right" style="margin-right:10px;margin-left:10px"><i class="fa fa-save"></i> Save</button>
  <button (click)="toggleEdit()" [hidden]="editmode" class="float-right" style="margin-right:10px;margin-left:10px"><i class="fa fa-pencil"></i> Edit</button>
</div>
<div class="clearfix"></div>
<div class="row">

  <div class="col-md-6">
    <div class="row">
      <div class="col">
        <label for="first-name">First Name</label>
        <input id="first-name" type="text" [(ngModel)]="patient.FirstName" [hidden]="!editmode" size="30" [style]="{'width':'100%'}">
        <span [hidden]="editmode">{{patient.FirstName}}</span>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="middle-name">Middle Name</label>
        <input id="middle-name" type="text" [(ngModel)]="patient.MiddleName" [hidden]="!editmode" size="30" [style]="{'width':'100%'}">
        <span [hidden]="editmode">{{patient.MiddleName}}</span>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="last-name">Last Name</label>
        <input id="last-name" type="text" [(ngModel)]="patient.LastName" [hidden]="!editmode" size="30" [style]="{'width':'100%'}">
        <span [hidden]="editmode">{{patient.LastName}}</span>
      </div>
    </div>
    <div class="row">
      <div class="col mt-0 mb-0">
        <label for="birthdate" class="toplabel">Date of Birth</label><br />
        <p-datepicker id="birthdate" [(ngModel)]="patient.BirthDate" [hidden]="!editmode" [style]="{'width':'100px'}" [inputStyle]="{'width':'100px'}"></p-datepicker>
        <span [hidden]="editmode">{{patient.BirthDate}}</span>
      </div>
    </div>
  </div>

  <div class="col-md-6">
    <div class="row">
      <div class="col mt-0 mb-0">
        <label for="gender" class="toplabel">Gender</label><br />
        <p-select [options]="genders" [(ngModel)]="patient.Gender" [hidden]="!editmode" [style]="{'width':'150px'}"></p-select>
        <span [hidden]="editmode">{{patient.Gender}}</span>
      </div>
    </div>
    <div class="row">
      <div class="col mt-0 mb-0">
        <label for="ethnicity" class="toplabel">Ethnicity</label><br />
        <p-select [options]="ethnicities" [(ngModel)]="patient.Ethnicity" [hidden]="!editmode" [style]="{'width':'150px'}"></p-select>
        <span [hidden]="editmode">{{patient.Ethnicity}}</span>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="last-name">Email Address</label>
        <input id="last-name" type="text" [(ngModel)]="patient.Email" [hidden]="!editmode" size="30" [style]="{'width':'100%'}">
        <span [hidden]="editmode">{{patient.Email}}</span>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="last-name">Phone Number</label>
        <input id="last-name" type="text" [(ngModel)]="patient.Phone" [hidden]="!editmode" size="30" [style]="{'width':'100%'}">
        <span [hidden]="editmode">{{patient.Phone}}</span>
      </div>
    </div>
  </div>
</div>
<div class="row border-bottom p-2 m-2"></div>
<div>
  <label for="address1">Address Search <i class="fa fa-search"></i></label>
  <AutocompleteComponent [hidden]="!editmode" addressType="geocode" [streetControl]="street" [cityControl]="city" [stateControl]="state" [zipControl]="zip"></AutocompleteComponent>
</div>
<div>
  <label for="address1">Address Line 1</label>
  <input #street type="text" size="40" [(ngModel)]="patient.HomeAddress.Address1" [hidden]="!editmode">
  <span [hidden]="editmode">{{patient.HomeAddress.Address1}}</span>
</div>
<div>
  <label for="address2">Address Line 2</label>
  <input id="address2" type="text" size="40" [(ngModel)]="patient.HomeAddress.Address2" [hidden]="!editmode">
  <span [hidden]="editmode">{{patient.HomeAddress.Address2}}</span>
</div>
<div>
  <div class="float-left">
    <label for="city">City, State, Zip</label>
    <input #city type="text" size="20" [(ngModel)]="patient.HomeAddress.City" [hidden]="!editmode">
    <span [hidden]="editmode">{{patient.HomeAddress.City}}</span>
    ,
  </div>
  <div class="float-left ml-2">
    <select #state [(ngModel)]="patient.HomeAddress.State" [hidden]="!editmode" style="height:30px">
      <option *ngFor="let x of states" value="{{x.value}}">{{x.label}}</option>
    </select>
    <span [hidden]="editmode">{{patient.HomeAddress.State}}</span>
  </div>
  <div class="float-left ml-2">
    <input #zip type="text" size="9" [(ngModel)]="patient.HomeAddress.ZipCode" [hidden]="!editmode">
    <!--<p-inputMask #zip mask="99999?-9999" [style]="{'width':'75px'}" [(ngModel)]="client.ZipCode" [hidden]="!editmode"></p-inputMask>-->
    <span [hidden]="editmode">{{patient.HomeAddress.ZipCode}}</span>
  </div>
</div>
